import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { withLocale, localeShape } from '../../locale'
import { setSessionItem } from '../../storeManager'
import { CreateLink } from '../../utils'
import messages from './messages'
import FormattedCurrency from '../FormattedCurrency'
import { connect } from 'react-redux'
import { selectIsPremium, selectIsLoggedIn } from '../../store/userSlice'
import {
  selectPricingConfig,
  setCoupon,
  getPlanWithLowestMonthlyPrice,
} from '../../store/pricingSlice'
import { trackStartRegistration } from '../../analytics'

class PremiumButton extends React.Component {
  static propTypes = {
    GALabel: PropTypes.string,
    countdown: PropTypes.bool,
    marginless: PropTypes.bool,
    absoluteFromPrice: PropTypes.bool,
    signUpCopy: PropTypes.bool,
    signUpCopyGreen: PropTypes.bool,
    signUpCopyBlock: PropTypes.bool,
    signupCopyShadowBlack: PropTypes.bool,
    onClickFunc: PropTypes.func,
    onClickFuncMobile: PropTypes.func,
    newStartpage: PropTypes.bool,
    priceInside: PropTypes.bool,
    locale: localeShape,
    isPremium: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    cheapestPlan: PropTypes.object,
    discount: PropTypes.number,
    currency: PropTypes.string,
    coupon: PropTypes.string,
    plansPage: PropTypes.bool,
    inlineBlock: PropTypes.bool,
    extraClass: PropTypes.string,
    jumbotron: PropTypes.bool,
    setCoupon: PropTypes.func,
  }

  static defaultProps = {
    GALabel: 'Not set',
    countdown: true,
    marginless: false,
    absoluteFromPrice: false,
    signUpCopy: true,
    signUpCopyGreen: false,
    signUpCopyBlock: false,
    signupCopyShadowBlack: false,
    newStartpage: false,
    priceInside: false,
  }
  constructor(props) {
    super(props)

    this.state = {
      signUpCopy: this.props.signUpCopy,
      signUpCopyGreen: this.props.signUpCopyGreen,
    }

    this.handleClick = this.handleClick.bind(this)
    this.renderLink = this.renderLink.bind(this)
    this.setSignUpCopyButtonClasses = this.setSignUpCopyButtonClasses.bind(this)
  }

  handleClick(e) {
    if (this.props.coupon) {
      this.props.setCoupon(this.props.coupon)
    }

    if (this.props.newStartpage) {
      setSessionItem('signup-init', 'New startpage: ' + this.props.GALabel)
      trackStartRegistration({
        entryPoint: this.props.GALabel,
        flowName: 'Regular',
      })
    } else if (this.props.plansPage) {
      setSessionItem('signup-init', 'Plans page: ' + this.props.GALabel)

      trackStartRegistration({
        entryPoint: this.props.GALabel,
        flowName: 'Regular',
      })

      const blurEl = document.querySelector('body > div')

      if (blurEl.classList.contains('c-blur')) {
        blurEl.classList.remove('c-blur--active')
        blurEl.parentNode.removeChild(blurEl.nextSibling)
      }
    }

    if (this.props.onClickFunc) {
      e.preventDefault()
      this.props.onClickFunc()
    }

    if (this.props.onClickFuncMobile) {
      e.preventDefault()
      this.props.onClickFuncMobile()
    }
  }

  renderFromPrice() {
    const { cheapestPlan, discount, currency } = this.props
    if (!cheapestPlan) return false

    return (
      <p
        className={`${
          this.props.priceInside
            ? 'c-premium-button__price-inside'
            : 'c-premium-button__from-price whitespace-no-wrap'
        }${
          this.props.absoluteFromPrice
            ? ' c-premium-button__from-price--absolute'
            : ''
        }`}
        key={cheapestPlan.duration}
      >
        {!discount && (
          <Fragment>
            <FormattedMessage {...messages.from} />{' '}
            <FormattedCurrency
              currency={currency}
              value={cheapestPlan.pricePerMonth}
            />
            {'/'}
            {this.props.priceInside ? (
              <FormattedMessage {...messages.shortMon} />
            ) : (
              <FormattedMessage {...messages.month} />
            )}
          </Fragment>
        )}
        {!!discount && cheapestPlan.originalPrice && (
          <Fragment>
            {this.props.priceInside && (
              <Fragment>
                <FormattedMessage {...messages.from} />{' '}
              </Fragment>
            )}
            <del className="strikethrough">
              <FormattedCurrency
                currency={currency}
                value={
                  Math.round(
                    (cheapestPlan.originalPrice / cheapestPlan.duration) * 100
                  ) / 100
                }
                round
              />
            </del>{' '}
            <ins>
              <FormattedCurrency
                currency={currency}
                value={cheapestPlan.pricePerMonth}
                round
              />
            </ins>
            {'/'}
            {this.props.priceInside ? (
              <FormattedMessage {...messages.shortMon} />
            ) : (
              <FormattedMessage {...messages.month} />
            )}
          </Fragment>
        )}
        {!!discount && !this.props.priceInside && (
          <Fragment>
            {' — '}
            <FormattedMessage {...messages.save} /> <b>{discount}%</b>!
          </Fragment>
        )}
      </p>
    )
  }

  setClasses() {
    let classes = 'c-premium-button'

    if (this.props.inlineBlock) {
      classes += ' c-premium-button--inline-block'
    }

    if (this.props.marginless) {
      classes += ' c-premium-button--marginless'
    }

    if (this.props.extraClass) {
      classes = classes + '  ' + this.props.extraClass
    }

    return classes
  }

  renderLink() {
    if (this.props.isLoggedIn && !this.props.isPremium) {
      return CreateLink('upgrade/', this.props.locale.language)
    } else {
      return CreateLink('signup/?premium=1', this.props.locale.language)
    }
  }

  setSignUpCopyButtonClasses() {
    let classes = 'c-button c-premium-button__cta c-premium-button__cta--signup'

    if (this.props.jumbotron || this.props.signupCopyShadowBlack)
      classes += ' c-button--shadow-black'

    this.state.signUpCopyGreen
      ? (classes += ' c-button--primary')
      : (classes += ' c-button--premium')

    if (this.props.signUpCopyBlock) classes += ' c-button--block'

    if (this.props.priceInside) classes += ' c-premium-button--price-inside'

    return classes
  }

  render = () => (
    <div className={this.setClasses()} data-uid="PremiumButton">
      {!this.state.signUpCopy && (
        <Link
          to={this.renderLink()}
          className={
            this.props.jumbotron
              ? 'c-button c-button--premium c-button--shadow-black  c-premium-button__cta'
              : 'c-button c-button--premium  c-premium-button__cta'
          }
          onClick={this.handleClick}
        >
          {this.props.isLoggedIn && !this.props.isPremium && (
            <span>
              <FormattedMessage {...messages.upgradeTo} />{' '}
              <span className="c-premium-button__cta-big-text">Premium</span>
            </span>
          )}
          {!this.props.isLoggedIn && (
            <span>
              <FormattedMessage {...messages.get} /> Lifesum
            </span>
          )}
        </Link>
      )}
      {this.state.signUpCopy && (
        <Link
          to={this.renderLink()}
          className={this.setSignUpCopyButtonClasses()}
          onClick={this.handleClick}
        >
          {this.props.isLoggedIn && !this.props.isPremium && (
            <span>
              <FormattedMessage {...messages.upgradeTo} />
              <span>{' Premium'}</span>
              {this.props.priceInside && this.renderFromPrice(true)}
            </span>
          )}
          {!this.props.isLoggedIn && (
            <span>
              <FormattedMessage {...messages.signUp} />
              {this.props.priceInside && this.renderFromPrice(true)}
            </span>
          )}
        </Link>
      )}
      {!this.props.isPremium &&
        !this.props.priceInside &&
        this.renderFromPrice()}
    </div>
  )
}

export default connect(
  (state, { coupon }) => {
    const config = selectPricingConfig(coupon || undefined)(state) || {}

    return {
      isLoggedIn: selectIsLoggedIn(state),
      isPremium: selectIsPremium(state),
      cheapestPlan: config.products
        ? getPlanWithLowestMonthlyPrice(config.products)
        : undefined,
      discount: config.discount,
      currency: config.currency,
    }
  },
  {
    setCoupon,
  }
)(withLocale(PremiumButton))
